module.exports = __webpack_public_path__ + "static/media/sme.e3bc23c5.png";